import $ from 'jquery';
import 'select2';
import { renderQuantity } from '../conversion';
import { db } from '../database';
import { localize } from '../i18n';
import { addStandaloneIngredient, removeStandaloneIngredient } from '../models/ingredients';
export { aggregateQuantities, renderProduct };
function aggregateQuantities(ingredients) {
    const quantities = Object.create(null);
    $.each(ingredients, (_, ingredient) => {
        var _a, _b;
        if (!ingredient.quantity)
            return;
        const magnitude = (_a = ingredient.quantity.magnitude) !== null && _a !== void 0 ? _a : 0;
        if (!magnitude)
            return;
        const units = (_b = ingredient.quantity.units) !== null && _b !== void 0 ? _b : '';
        if (!(units in quantities))
            quantities[units] = 0;
        quantities[units] += ingredient.quantity.magnitude;
    });
    return quantities;
}
function renderProduct(product, ingredients) {
    const quantities = aggregateQuantities(ingredients);
    const fragments = [];
    $.each(quantities, (units, magnitude) => {
        const quantity = renderQuantity({ units: units, magnitude: magnitude });
        if (!quantity.units && !quantity.magnitude)
            return;
        if (fragments.length)
            fragments.push(' + ');
        if (quantity.magnitude) {
            fragments.push(quantity.magnitude);
            fragments.push(' ');
        }
        if (quantity.units) {
            fragments.push(quantity.units);
        }
    });
    fragments.push(' ');
    fragments.push(product.name);
    return fragments.join('');
}
function renderCategory(category) {
    const fieldset = $('<fieldset />', { 'class': category });
    const legend = $('<legend />', { 'data-i18n': `[html]categories:${category}` });
    fieldset.append(legend);
    return fieldset;
}
function getProductId(el) {
    const target = $(el).hasClass('product') ? $(el) : $(el).parents('.product');
    return target.data('id');
}
function toggleProductState() {
    const productId = getProductId(this);
    void db.basket.get(productId, item => {
        if (item)
            void db.basket.delete(productId);
        else
            void db.basket.put({ product_id: productId, magnitude: null, units: null });
    });
}
function productElement(product, ingredients) {
    const checkbox = $('<input />', {
        'type': 'checkbox',
        'name': 'products[]',
        'value': product.id
    });
    void db.basket.get(product.id, item => {
        checkbox.attr('checked', !!item);
    });
    const label = $('<label />', {
        'class': 'product',
        'data-id': product.id,
        'click': toggleProductState
    });
    label.append(checkbox);
    const text = renderProduct(product, ingredients);
    const textContainer = $('<span />', { 'html': text });
    label.append(textContainer);
    if (!ingredients.find(ingredient => ingredient.recipe_id)) {
        const removeButton = $('<span />', {
            'data-role': 'remove',
            'click': function () {
                removeStandaloneIngredient(product);
            }
        });
        label.append(removeButton);
    }
    return label;
}
function populateNotifications() {
    const requiredProducts = new Set();
    void db.ingredients.each(ingredient => {
        requiredProducts.add(ingredient.product_id);
    }).then(() => {
        const total = requiredProducts.size;
        const empty = total === 0;
        $('header span.notification.shopping-list').toggle(!empty);
        if (empty)
            return;
        // TODO: Figure out why display:block is being applied incorrectly, and
        // then remove this workaround
        $('header span.notification.shopping-list').css({ 'display': 'inline' });
        void db.basket.count(found => {
            $('header span.notification.shopping-list').text(found + '/' + total);
        });
    });
}
async function getProductsByCategory(servingsByRecipe) {
    const ingredientsByProduct = new Map();
    const productsByCategory = new Map();
    await db.transaction('r', db.ingredients, db.products, () => {
        void db.ingredients.each(ingredient => {
            var _a;
            const servings = servingsByRecipe[ingredient.recipe_id];
            if (((_a = ingredient.quantity) === null || _a === void 0 ? void 0 : _a.magnitude) && servings.scheduled) {
                ingredient.quantity.magnitude *= servings.scheduled;
                ingredient.quantity.magnitude /= servings.recipe;
            }
            void db.products.get(ingredient.product_id, product => {
                if (!product)
                    return;
                if (!ingredientsByProduct.has(product.id))
                    ingredientsByProduct.set(product.id, []);
                ingredientsByProduct.get(product.id).push(ingredient);
                if (!productsByCategory.has(product.category))
                    productsByCategory.set(product.category, new Map());
                productsByCategory.get(product.category).set(product.id, product);
            });
        });
    });
    return {
        ingredientsByProduct: ingredientsByProduct,
        productsByCategory: productsByCategory,
    };
}
async function getServingsByRecipe() {
    const servingsByRecipe = Object.create(null);
    await db.transaction('r', db.recipes, db.meals, () => {
        void db.recipes.each(recipe => {
            servingsByRecipe[recipe.id] = { recipe: recipe.servings, scheduled: 0 };
        });
        void db.meals.each(meal => {
            servingsByRecipe[meal.recipe_id].scheduled += meal.servings;
        });
    });
    return servingsByRecipe;
}
function renderShoppingList() {
    void getServingsByRecipe().then(servingsByRecipe => {
        void getProductsByCategory(servingsByRecipe).then(results => {
            const shoppingList = $('#shopping-list .products').empty();
            const sortedCategories = Array.from(results.productsByCategory.keys()).sort();
            $.each(sortedCategories, (_, category) => {
                const products = results.productsByCategory.get(category);
                const categoryElement = renderCategory(category);
                for (const productId of products.keys()) {
                    const product = products.get(productId);
                    const ingredients = results.ingredientsByProduct.get(productId);
                    categoryElement.append(productElement(product, ingredients));
                }
                shoppingList.append(categoryElement);
            });
            localize(shoppingList);
            populateNotifications();
        });
    });
}
function bindShoppingListInput(element, placeholder) {
    $(element).select2({
        ajax: {
            url: '/api/autosuggest/ingredients',
            dataType: 'json',
            data: params => ({ pre: params.term }),
            processResults: data => ({
                results: data.map(item => ({
                    id: item.id,
                    text: item.name,
                    product: item
                }))
            })
        },
        minimumInputLength: 3,
        placeholder: placeholder,
        selectOnClose: true
    });
    $(element).on('select2:select', function (event) {
        $(this).val(null).trigger('change');
        const product = event.params.data.product;
        void db.ingredients
            .where("product_id")
            .equals(product.id)
            .count(count => { if (count === 0)
            addStandaloneIngredient(product); });
    });
}
$(function () {
    bindShoppingListInput('#shopping-list-entry', 'e.g. rice');
    db.on('changes', changes => { if (changes.find(c => c.table === 'meals'))
        renderShoppingList(); });
    db.on('changes', changes => { if (changes.find(c => c.table === 'ingredients'))
        renderShoppingList(); });
    db.on('changes', changes => { if (changes.find(c => c.table === 'basket'))
        populateNotifications(); });
    renderShoppingList();
});
